<template>
  <header>
    <button class="close scan-modal-header__close-btn" @click="$emit('closeClick')"></button>
    <h2>Scan Product Barcode</h2>
  </header>
</template>

<style scoped lang="scss">
.scan-modal-header {
  &__close-btn {
    background-color: initial;
    border: none;
    top: 14px;
    left: 12px;
  }
}
</style>
